import React, { useState, useEffect } from 'react';
import { MDBDataTableV5 } from 'mdbreact';
import { CSVLink } from 'react-csv';
import { FaCloudDownloadAlt } from 'react-icons/fa';

const TopSalesTable = ({ salesSku, salesQuery, salesData }) => {
	const today = new Date();
	const csvDate = `${today.getFullYear()}_${
		today.getMonth() + 1
	}_${today.getDate()}`;

	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);
	const [labels, setLabels] = useState([]);
	const [salesName, setSalesName] = useState('Brand');
	const [retailer, setRetailer] = useState('');
	const [retailerName, setRetailerName] = useState('Top Retailers');
	const [rowsData2Csv, setRowsData2Csv] = useState({ columns: [], rows: [] });
	const [csvData, setCsvData] = useState([]);

	useEffect(() => {
		if (salesData && salesData.topData) {
			setRowsData(Object.values(salesData.topData)[0]);
			setRetailerName(Object.keys(salesData.topData)[0]);
		}
	}, [salesData]);

	function onChange(value) {
		setRetailer(value);
		if (value === 'Top Chain') {
			setRetailerName('Top Retailers');
		} else {
			if (value) {
				setRetailerName(value + 's');
			} else {
				setRetailerName('Top Retailers');
			}
		}
		setRowsData(salesData.topData[value]);
	}

	const dashboardHeadings = [
		{
			label: 'Name',
			field: 'name',
		},
		{
			label: 'Region',
			field: 'region',
		},
		{
			label: 'Sales',
			field: 'sales',
		},
		{
			label: 'Users',
			field: 'users',
		},
	];

	useEffect(() => {
		if (rowsData && rowsData.length) {
			let data = {
				columns: dashboardHeadings,
				rows:
					rowsData && rowsData.length
						? rowsData.map((e, i) => {
								return {
									name: e.name ? e.name : '',
									users: e.users ? e.users : '',
									sales: e.sales ? e.sales : '',
									region: e.region ? e.region : '',
									channel: e.chain ? e.chain : '',
								};
						  })
						: [],
			};

			// console.log('data', data);
			setRowsData2Csv({
				columns: data.columns,
				rows: data.rows,
			});
			//
			data.rows && setCsvData(data.rows);
		}
	}, [rowsData]);

	const dashboardHeadingCsv = [
		{
			label: 'Name',
			key: 'name',
		},
		{
			label: 'Region',
			key: 'region',
		},
		{
			label: 'Sales',
			key: 'sales',
		},
		{
			label: 'Users',
			key: 'users',
		},
		{
			label: 'Channel',
			key: 'channel',
		},
	];

	// console.log('salesData', salesData);
	// console.log('rowsData', rowsData);

	return (
		<div className='p-3 position-relative' style={{ height: '100%' }}>
			<div
				className='mb-3 text-muted fw-bold text-center'
				style={{ fontSize: '1.3rem' }}>
				{retailerName}
			</div>
			<div className='mb-3' style={{ fontSize: '1.3rem' }}>
				<div className=''>
					<select
						type='select'
						name={retailer}
						className='form-select mr-2'
						value={retailer}
						onChange={(e) => onChange(e.target.value)}>
						<option value=''>Select</option>
						<option value='Top Chain'>Top Retailers</option>
						<option value='Top Promoter'>Top Promoters</option>
					</select>
				</div>
			</div>

			<div className='text-center'>
				<MDBDataTableV5
					data={rowsData2Csv}
					// bordered
					noBottomColumns
					small
					responsive
					hover
					// paging={false}
					searching={false}
					entriesOptions={[5]}
					entries={5}
					// pagesAmount={4}
					// fullPagination
				/>
			</div>
			<div
				className='position-absolute'
				style={{
					bottom: '-0.5rem',
					border: 'none',
					textDecoration: 'none',
				}}>
				{rowsData2Csv && rowsData2Csv.rows && (
					<CSVLink
						data={csvData && csvData}
						headers={dashboardHeadingCsv}
						filename={`top-performers${csvDate}.csv`}
						target='_blank'>
						<FaCloudDownloadAlt color='#3366CB' size='1.5rem' />
					</CSVLink>
				)}
			</div>
		</div>
	);
};

export default TopSalesTable;
